import Vue from 'vue';
import Vuex from 'vuex';
import * as firebase from '../firebase';
import { router } from './router';
import { itemsColeta2Collection, auth, db, firestore } from '../firebase';
import { shuffle as _shuffle } from "lodash";
import { getInconsistentResponses } from './services/questions-service';

Vue.use(Vuex);

const TEST_LIMIT = 340

export default new Vuex.Store({
  state: {
    userProfile: {},
    assessmentItems: [],
    isLoading: false,
    currentItem: 0,
    currentItemId: null,
    currentDocRefId: '',
    userId: null,
    shouldTrackMouse: false,
    mouseItemDynamics: [],
    item_factor_categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    sorted_current_items_categories: [],
    execution: 0,
  },
  getters: {
    userProfile: state => state.userProfile,
    isLoading: state => {
      return state.isLoading;
    },
    assessmentItems: state => {
      return state.assessmentItems;
    },
    currentItem: state => {
      return state.currentItem;
    },
    currentDocRef: state => {
      return state.currentDocRefId;
    },
    currentItemTitle: state => {
      return state.assessmentItems[state.currentItem].item;
    },
    shouldTrackMouse: state => {
      return state.shouldTrackMouse;
    },
    getExecution: state => state.execution
  },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setUserId(state, val) {
      state.userId = val;
    },
    setAssessmentItems(state, val) {
      state.assessmentItems = val;
    },
    setLoading(state, val) {
      state.isLoading = val;
    },
    setCurrentDocRefId(state, val) {
      state.currentDocRefId = val
    },
    incrementCurrentItem(state) {
      state.currentItem++;
    },
    resetCurrentItem(state) {
      state.currentItem = 0;
    },
    resetAssessmentItems(state) {
      state.assessmentItems = [];
    },
    setShouldTrackMouse(state, val) {
      state.shouldTrackMouse = val;
    },
    ['SET_MOUSE_ITEM_DYNAMICS'](state, val) {
      state.mouseItemDynamics.push(val);
    },
    resetMouseDynamics(state, val) {
      state.mouseItemDynamics = [];
    },
    setCurrentExecution(state, val) {
      state.execution = val
    }
  },
  actions: {
    login({ commit }, form) {
      return new Promise((resolve, reject) => {

        firebase.auth
          .signInWithEmailAndPassword(form.email, form.password)
          .then(function (success) {
            commit('setUserId', success.user.uid);
            return db.collection('cadastro_coleta_2').doc(success.user.uid).get();
          })
          .then(function (doc) {
            commit('setUserProfile', doc.data());
            resolve(doc.data());
          })
          .catch(function (error) {
            reject(error);
          });

      });

    },

    async logout({ commit, state }, payload) {
      firebase.auth
        .signOut()
        .then(function () {
          const query = payload?.completed_test ? { completed_test: true } : {}
          if (state.userProfile.user_type === 2) {
            query.t = "compliance";
          }
          commit('setUserProfile', '');
          router.push({ name: 'Login', query });
        })
        .catch(function (error) {
        });
    },

    async forgotPassword({ commit, state }, payload) {
      let actionCodeSettings = {
        url: 'https://examined-87138.web.app/'
      };
      await auth.sendPasswordResetEmail(payload.email, actionCodeSettings).then(function () {
      }).catch(function (error) {
      });

    },

    startNewAssessment({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true);
        commit('setShouldTrackMouse', false);
        commit('resetCurrentItem');
        commit('resetAssessmentItems');
        commit('setCurrentDocRefId', null);
        db.collection('cadastro_coleta_2')
          .doc(auth.currentUser.uid)
          .get()
          .then((snapshot) => {
            const profile = snapshot.data();
            return db.collection('coleta_2_assessments').add({
              accept_terms: true,
              created: firestore.Timestamp.now(),
              user_id: profile.user_id,
              birthplace: profile.birthplace,
              user_name: profile.name,
              user_email: profile.email,
              user_type: profile.user_type
            });
          })
          .then((docRef) => {
            commit('setCurrentDocRefId', docRef.id);
            return db.collection('coleta_2_items').doc('items').get();
          })
          .then((doc) => {
            commit('setCurrentExecution', 1);
            commit('setAssessmentItems', (() => {
              const filteredItems = doc.data().list.filter((item) => item.id < TEST_LIMIT);
              const shuffled = _shuffle(filteredItems);
              return shuffled;
            })());

            return db.collection('coleta_2_mouse')
              .doc(state.currentDocRefId)
              .set({
                created: firestore.Timestamp.now(),
                user_id: auth.currentUser.uid,
                assessment_id: state.currentDocRefId,
                execution: state.execution
                //mouse_dynamics: []
              });

          })
          .then(async () => {
            commit('setLoading', false);
            commit('setShouldTrackMouse', true);
            resolve();
          })

          .catch(error => {
            //commit('setLoading', false);
            commit('setShouldTrackMouse', false);
            reject(error);
          });
      });

    },

    answer({ dispatch, commit, state }, payload) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true);
        commit('setShouldTrackMouse', false);
        dispatch('updateAssessment', payload)
          .then(async () => {
            if (state.execution === 1 && state.currentItem === state.assessmentItems.length - 1) {
              const assessment = await db.collection('coleta_2_assessments').doc(state.currentDocRefId).get();
              const responses = assessment.data().answers;
              const items = await db.collection('coleta_2_items').doc('items').get();
              const allItems = items.data()
              const filteredItems = allItems.list.filter((item) => item.id < TEST_LIMIT);
              const inconsistentResponsesIds = getInconsistentResponses(responses, filteredItems);
              if (!inconsistentResponsesIds || inconsistentResponsesIds.length === 0) {
                dispatch("completeAssessment").then(() => {
                  commit('resetCurrentItem');
                  commit('setLoading', false);
                  commit('setCurrentExecution', 0);
                  commit('setAssessmentItems', []);
                  router.replace({ name: "Finish" });
                  resolve();
                });

              }
              let limitedSizeInconsistentResponsesIds;

              if (inconsistentResponsesIds.length > 50) {
                limitedSizeInconsistentResponsesIds = _shuffle(_shuffle(inconsistentResponsesIds).slice(0, 50));
              } else {
                limitedSizeInconsistentResponsesIds = _shuffle(inconsistentResponsesIds);
              }
              const shuffled = _shuffle(filteredItems.filter((item) => limitedSizeInconsistentResponsesIds
                .includes(parseInt(item.id))));
              const secondExecutionItems = shuffled;
              commit('setAssessmentItems', secondExecutionItems);
              commit('resetCurrentItem');
              commit('setCurrentExecution', 2);
              commit('setLoading', false);
              commit('resetMouseDynamics');
              commit('setShouldTrackMouse', true);
              resolve();

            } else if (state.execution === 2 && state.currentItem === state.assessmentItems.length - 1) {
              dispatch("completeAssessment").then(() => {
                commit('resetCurrentItem');
                commit('setLoading', false);
                commit('setCurrentExecution', 0);
                commit('setAssessmentItems', []);
                router.replace({ name: "Finish" });
                resolve();
              });

            } else {
              commit('incrementCurrentItem');
              commit('setLoading', false);
              commit('resetMouseDynamics');
              commit('setShouldTrackMouse', true);
              resolve();
            }

          })
          .catch(function (error) {
            commit('setShouldTrackMouse', false);
          });
      });
    },

    updateAssessment({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        db.collection('coleta_2_assessments').doc(state.currentDocRefId)
          .update({
            answers: firestore.FieldValue.arrayUnion(payload)
          })
          .then(() => {
            const subCollectionDocId = state.execution === 1 ? payload.item_id : `${payload.item_id}_${state.execution}`
            return db.collection('coleta_2_mouse').doc(state.currentDocRefId)
              .collection('items').doc(subCollectionDocId).set({
                mouse_dynamics: state.mouseItemDynamics,
                item_id: parseInt(payload.item_id),
                execution: state.execution
              });
          })
          .then(function () {
            resolve();
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },

    completeAssessment({ dispatch, state, commit }) {

      return new Promise((resolve, reject) => {
        commit('setLoading', true);

        db.collection('coleta_2_assessments')
          .doc(state.currentDocRefId)
          .get()
          .then(function (snapshot) {
            db.collection('coleta2_testes_concluidos_validos')
              .doc(state.currentDocRefId)
              .set(snapshot.data()).then(() => {
                return;
              })
            return;
          })
          .then(function () {
            commit('resetCurrentItem');
            commit('resetAssessmentItems');
            commit('setCurrentDocRefId', null);
            commit('setLoading', false);
            commit('setCurrentExecution', 0);
            //completedTest to true in user profile

            db.collection('cadastro_coleta_2').doc(auth.currentUser.uid)
              .update({
                completed_test: true
              })

            resolve();
          })
          .catch(function (error) {
            commit('setLoading', false);
            reject(error);
          });
      });
    },

    saveMouseDynamics({ dispatch, state, commit }, payload) {
      commit('SET_MOUSE_ITEM_DYNAMICS', payload);
    }

  }


});